import { makeStyles } from '@material-ui/core/styles';


export const PollPanelStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },

  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  tarjetas: {
    padding: theme.spacing(2),
    margin: theme.spacing(2),
    backgroundColor: '#f5f5f5', // Cambia el color de fondo según tus necesidades
    borderRadius: '15px',
    marginTop:' 5%'
},
  fixedHeight: {
    height: 350,
  },
  buttonProgress: {
    color: 'primary',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  rootList: {
    width: '100%',
    backgroundColor: "#f5f5f5",
  },
  titleList :{
    textAlign: "center",
    margin: "0 auto",
    padding: 5,
    color: "black",
    fontSize: 15
  },
  tableAction:{
    paddingLeft: 0,
    paddingRight: 0,
    margin: "0 auto",
    textAlign: "center",
    alignItems: "center"
},
modal: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
},
input: {
  display: 'none',
},
 searchContainer: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end', // Alinea al final (derecha)
  paddingRight: theme.spacing(1), // Agrega un poco de espacio a la derecha
},
}));